import type { RouteRecordRaw } from 'vue-router'

export const dashRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    meta: {
      layout: 'dash',
      protected: true,
    },
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('@/pages/home/Index'),
      },
    ],
  },
]
